// extracted by mini-css-extract-plugin
export default {"card":"SettingsCard_card__ds-A8"};